import { isNumeric, isValidEmail } from '@/utils/validators';
import { InputHTMLAttributes } from 'react';

export type InputText = {
  valid: boolean;
  label: string;
  value: string;
  validator: (value: string) => boolean;
  getErrorMessage: (value: string) => string;
  errorMessage: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'value'>;

export const getEmptyError = (value: string) =>
  value === '' ? 'Veuillez entrer une valeur' : '';

export const getEmailError = (email: string) =>
  !isValidEmail(email) ? 'Veuillez entrer une adresse mail valide' : '';

export const getPhoneNumError = (phoneNumber: string) =>
  phoneNumber !== '' && (!isNumeric(phoneNumber) || phoneNumber.length < 7)
    ? 'Veuillez entrer un numero de telephone valide'
    : '';

export const getMinLenError = (
  value: string,
  minLen: number,
  customMsg?: string
) =>
  value !== '' && value.length < minLen
    ? customMsg
      ? customMsg
      : 'Un minimum de ' + minLen + ' caractères doivent être saisis'
    : '';
